import { use } from 'react'
import { ThemeContext, type ThemeValue } from './themeContext'

export function useTheme(): ThemeValue {
  return use(ThemeContext)
}
